import { Action, handleActions } from 'redux-actions';
import {
  PROFILE_SET,
  PROFILE_SET_CHECKOUTS,
  PROFILE_SET_NAME,
  PROFILE_SET_PUBLISHER,
} from './constants/ActionTypes';
import {
  ICheckout,
  IProfileData,
  IProfileNameData,
  IProfilePublisherData,
  IProfileState,
} from './model';

const initialState: IProfileState = {
  checkouts: null,
  name: '',
  uid: null,
};

export default handleActions<
  IProfileState,
  IProfileData | IProfilePublisherData | IProfileNameData | ICheckout[]
>(
  {
    [PROFILE_SET]: (
      state: IProfileState,
      action: Action<IProfileData>
    ): IProfileState => {
      const newState = {
        ...state,
        uid: action.payload!.uid,
      };
      return newState;
    },

    [PROFILE_SET_PUBLISHER]: (
      state: IProfileState,
      action: Action<IProfilePublisherData>
    ): IProfileState => {
      const newState = {
        ...state,
        pubId: action.payload!.pubId,
      };
      return newState;
    },

    [PROFILE_SET_NAME]: (
      state: IProfileState,
      action: Action<IProfileNameData>
    ): IProfileState => {
      const newState = {
        ...state,
        name: action.payload!.name,
      };
      return newState;
    },

    [PROFILE_SET_CHECKOUTS]: (
      state: IProfileState,
      action: Action<ICheckout[]>
    ): IProfileState => {
      const newState = {
        ...state,
        checkouts: action.payload ? action.payload : [],
      };
      return newState;
    },
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/profile/reducer.ts